"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSPath = require("jspath");
var MigrationTransformBase = /** @class */ (function () {
    function MigrationTransformBase(options) {
        this.options = options;
    }
    MigrationTransformBase.prototype.getParentInstances = function (seed, parentJsPath) {
        var parentInstances = parentJsPath ? JSPath.apply(parentJsPath, seed) : [seed];
        return parentInstances;
    };
    return MigrationTransformBase;
}());
exports.MigrationTransformBase = MigrationTransformBase;
//# sourceMappingURL=MigrationTransformBase.js.map